// Copyright 2024, Imprivata, Inc.  All rights reserved.

import { getCurrentSpan, type TraceContext } from '@imprivata-cloud/common';
import { getWorkflowId } from '../tracing';
import type { Span } from '@opentelemetry/api';

export function getB3Descriptor(span: Span): string {
  // https://github.com/openzipkin/b3-propagation#sampling-state-2
  const sampled = '1';
  // @ts-expect-error - Unknown
  const { traceId, spanId } = span._spanContext;

  return `${traceId as string}-${spanId as string}-${sampled as string}`;
}

const workflowId = getWorkflowId();

const currentSpan = getCurrentSpan();
const traceContext: TraceContext = {
  workflowId,
  spanContext: currentSpan ? getB3Descriptor(currentSpan) : '',
};

type ImprAgentApi = {
  window: {
    showWindow2: (
      workflowId: string,
      traceContext: TraceContext,
      value: Array<'hide' | 'show' | 'showmaximized'>,
    ) => void;
  };
  authn: {
    endJourneyAndCloseWindow: (
      workflowId: string,
      traceContext: TraceContext,
    ) => void;
  };
};

declare global {
  interface Window {
    impr?: ImprAgentApi;
  }
}

export const showWindow = () => {
  if (window.impr?.window.showWindow2) {
    window.impr?.window.showWindow2(workflowId, traceContext, ['show']);
  }
};

export const hideWindow = () => {
  if (window.impr?.window.showWindow2) {
    window.impr?.window.showWindow2(workflowId, traceContext, ['hide']);
  }
};

export const endJourneyAndCloseWindow = () => {
  if (window.impr) {
    window.impr.authn.endJourneyAndCloseWindow(workflowId, traceContext);
  }
};
